import type { InfraAgent } from "@/types";

export const mockAgents: InfraAgent[] = [
  {
    id: "1",
    title: "Kubernetes Cluster Setup Agent",
    description:
      "Automated Kubernetes cluster provisioning with best practices for production environments. Includes monitoring, logging, and security configurations.",
    tags: ["kubernetes", "aws", "monitoring", "security"],
    competencies: ["deployment", "container", "monitoring", "security"],
    githubUrl: "https://github.com/example/k8s-agent",
    websiteUrl: "https://k8s-agent.dev",
    stats: {
      likes: 127,
      views: 1450,
    },
    metadata: {
      github_stars: 245,
      license: "MIT",
      language: "Python",
    },
  },
  {
    id: "2",
    title: "Serverless API Stack",
    description:
      "Complete serverless API infrastructure with Lambda, API Gateway, DynamoDB, and CloudFormation. Includes CI/CD pipeline and automated testing.",
    tags: ["serverless", "aws", "lambda", "dynamodb", "ci/cd"],
    competencies: ["serverless", "cicd", "database"],
    githubUrl: "https://github.com/example/serverless-api",
    stats: {
      likes: 89,
      views: 923,
    },
    metadata: {
      github_stars: 178,
      license: "Apache-2.0",
      language: "TypeScript",
    },
  },
  {
    id: "3",
    title: "Multi-Cloud Database Migration",
    description:
      "Intelligent database migration agent supporting PostgreSQL, MySQL, and MongoDB across AWS, Azure, and GCP with zero-downtime migrations.",
    tags: ["database", "migration", "postgresql", "mongodb", "multi-cloud"],
    competencies: ["database", "cloud-platform"],
    githubUrl: "https://github.com/example/db-migration",
    websiteUrl: "https://dbmigrate.tools",
    stats: {
      likes: 156,
      views: 2100,
    },
    metadata: {
      github_stars: 312,
      license: "MIT",
      language: "Go",
    },
  },
  {
    id: "4",
    title: "Container Registry & Security Scanner",
    description:
      "Private container registry with built-in vulnerability scanning, image signing, and automated security policy enforcement.",
    tags: ["docker", "security", "scanning", "registry", "vulnerabilities"],
    competencies: ["security", "container"],
    githubUrl: "https://github.com/example/secure-registry",
    stats: {
      likes: 203,
      views: 3200,
    },
    metadata: {
      github_stars: 427,
      license: "GPL-3.0",
      language: "Rust",
    },
  },
  {
    id: "5",
    title: "Terraform Module Generator",
    description:
      "AI-powered Terraform module generator that creates reusable infrastructure modules based on best practices and organization policies.",
    tags: ["terraform", "ai", "modules", "automation", "infrastructure"],
    competencies: ["iac", "cloud-platform"],
    githubUrl: "https://github.com/example/tf-generator",
    websiteUrl: "https://tfgen.ai",
    stats: {
      likes: 94,
      views: 1800,
    },
    metadata: {
      github_stars: 156,
      license: "MIT",
      language: "Python",
    },
  },
  {
    id: "6",
    title: "Observability Stack Deployment",
    description:
      "Complete observability stack with Prometheus, Grafana, Jaeger, and ELK. Includes pre-configured dashboards and alerting rules.",
    tags: ["monitoring", "prometheus", "grafana", "observability", "logging"],
    competencies: ["monitoring", "deployment"],
    githubUrl: "https://github.com/example/observability-stack",
    stats: {
      likes: 78,
      views: 1250,
    },
    metadata: {
      github_stars: 89,
      license: "Apache-2.0",
      language: "Go",
    },
  },
];

export const mockTags = [
  "kubernetes",
  "aws",
  "azure",
  "gcp",
  "docker",
  "terraform",
  "serverless",
  "lambda",
  "monitoring",
  "security",
  "database",
  "postgresql",
  "mongodb",
  "mysql",
  "ci/cd",
  "automation",
  "infrastructure",
  "observability",
  "logging",
  "grafana",
  "prometheus",
  "migration",
  "multi-cloud",
  "ai",
  "scanning",
  "vulnerabilities",
  "registry",
];
